import { render } from "./AdminQueries.vue?vue&type=template&id=2df41baa&scoped=true"
import script from "./AdminQueries.vue?vue&type=script&lang=js"
export * from "./AdminQueries.vue?vue&type=script&lang=js"

import "./AdminQueries.vue?vue&type=style&index=0&id=2df41baa&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df41baa"]])

export default __exports__